import { HelpOutline, LocalShipping, Payment, Security } from '@mui/icons-material';

export const getFaqData = (t) => [
  {
    category: t('support.faqCategories.general'),
    icon: HelpOutline,
    questions: [
      {
        q: t('support.faqGeneral.q1'),
        a: t('support.faqGeneral.a1'),
      },
      {
        q: t('support.faqGeneral.q2'),
        a: t('support.faqGeneral.a2'),
      },
      {
        q: t('support.faqGeneral.q3'),
        a: t('support.faqGeneral.a3'),
      },
    ],
  },
  {
    category: t('support.faqCategories.trackingDelivery'),
    icon: LocalShipping,
    questions: [
      {
        q: t('support.faqTracking.q1'),
        a: t('support.faqTracking.a1'),
      },
      {
        q: t('support.faqTracking.q2'),
        a: t('support.faqTracking.a2'),
      },
      {
        q: t('support.faqTracking.q3'),
        a: t('support.faqTracking.a3'),
      },
    ],
  },
  {
    category: t('support.faqCategories.paymentWallet'),
    icon: Payment,
    questions: [
      {
        q: t('support.faqPayment.q1'),
        a: t('support.faqPayment.a1'),
      },
      {
        q: t('support.faqPayment.q2'),
        a: t('support.faqPayment.a2'),
      },
      {
        q: t('support.faqPayment.q3'),
        a: t('support.faqPayment.a3'),
      },
    ],
  },
  {
    category: t('support.faqCategories.accountSecurity'),
    icon: Security,
    questions: [
      {
        q: t('support.faqAccount.q1'),
        a: t('support.faqAccount.a1'),
      },
      {
        q: t('support.faqAccount.q2'),
        a: t('support.faqAccount.a2'),
      },
      {
        q: t('support.faqAccount.q3'),
        a: t('support.faqAccount.a3'),
      },
    ],
  },
];
